module.exports = __webpack_public_path__ + "img/81-4a3133.png";